/* Converteste sumele scrise de mana pentru pietele care nu sunt trecute in tabelul din tema.
   Se aplica doar pe <span data-nk-money="valoare_in_centi_moneda_magazinului">.
   Daca moneda afisata e chiar moneda magazinului, nu atinge nimic. */
(function () {
  function convert() {
    var nodes = document.querySelectorAll('[data-nk-money]');
    if (!nodes.length) return;

    var S = window.Shopify || {};
    var cur = S.currency || {};
    var rate = parseFloat(cur.rate || '1');
    var active = cur.active || (S.country && S.country.currency) || null;
    if (!active) return;

    // moneda afisata = moneda magazinului, deci suma scrisa e deja corecta
    if (rate === 1 && (!S.currency || cur.active === cur.shop)) return;

    var fmt;
    try {
      fmt = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: active, maximumFractionDigits: 0
      });
    } catch (e) { return; }

    nodes.forEach(function (el) {
      var cents = parseFloat(el.getAttribute('data-nk-money'));
      if (isNaN(cents)) return;
      var converted = (cents / 100) * rate;
      // rotunjim in sus la intreg: preferam 55 in loc de 54.63 intr-o promisiune de livrare
      el.textContent = fmt.format(Math.ceil(converted));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', convert);
  } else {
    convert();
  }
  document.addEventListener('shopify:section:load', convert);
})();
